<template>
  <div v-if="country">
    <validation-observer ref="form" v-slot="{ handleSubmit }">
      <v-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <v-card outlined>
          <v-card-title v-if="country.id">Editing {{ translate(country.name) }}</v-card-title>
          <v-card-title v-else>Creating new country</v-card-title>
          <v-card-text>
            TODO: Missing region
            <m-field v-model="country.code" m="country" a="code" />
            <m-field v-model="country.name" m="country" a="name" i18n />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn type="submit" color="primary">{{$t('actions.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import ImageUploader from 'vue-image-upload-resize';
import formatter from "@/mixins/formatter";

@Component({components: {ImageUploader}, mixins: [formatter]})
export default class CountryForm extends Vue {

  @Prop() countryId;

  country = null;

  mounted() {
    // get or create country object
    if (this.countryId) {
      this.$api.get(`country/${this.countryId}?expand=region`).then(j => {
        this.country = j.data;
      });
    } else {
      this.country = {
        name: {},
      }
    }
  }

  onSubmit() {
    const call = this.countryId
      ? this.$api.patch(`country/${this.countryId}?expand=region`, this.country)
      : this.$api.post(`country?expand=region`, this.country)

    call.then(j => {
      this.$emit('save', j.data);
    }).catch(err => {
      if (err.response) this.$refs.form.setErrors(err.response.data);
      this.$snack.validationError(err.response.data)
    });
  }

  get rules() {
    return this.$store.state.rules;
  }

}
</script>

<style>
#fileInput {
  display: none;
}
h2 {
  margin: 1em 0;
}
</style>
